import { AspirationRequirementsType } from './types';

export const initialState: AspirationRequirementsType = {
  aspDate: new Date(),
  aspSite: null,
  opuTech: null,
  chuteTech: null,
  quickSearchValue: '',
  selectedAspiration: null,
  showForm: false,
  qcDataSubmitted: false,
};
